// extracted by mini-css-extract-plugin
export default {"people":"ApplicationPeopleSummary_people__cK8xo","person":"ApplicationPeopleSummary_person__hWsEw","name":"ApplicationPeopleSummary_name__Kt2Ao"};